<template>
    <div>
        <div id="map" style="width: 100%; height: 100vh"></div>
    </div>
</template>

<script>
// import rasterIcons from '../helpers/rasterIcons.json';

function startClustering(map, data) {
    const dataPoints = data.map(
        (item) =>
            new H.clustering.DataPoint(item.latitude, item.longitude, null, {
                guid: item.guid,
                icon: item.icon,
            }),
    );

    const clusteredDataProvider = new H.clustering.Provider(dataPoints, {
        clusteringOptions: {
            // Supported strategies: FASTGRID|GRID|DYNAMICGRID
            strategy: H.clustering.Provider.Strategy.DYNAMICGRID,
            // strategy: H.clustering.Provider.Strategy.FASTGRID,
            // Maximum radius of the neighbourhood
            eps: 128,
            // Minimum weight of points required to form a cluster
            minWeight: 2,
            // Spherical Mercator projection
            projection: H.geo.mercator,
        },
    });

    /*
    const getLocalIcon = (icon) =>
        new H.map.Icon(rasterIcons[`marker-${icon}`], {
            size: { w: 27, h: 32 },
        });
    */

    const customTheme = {
        getClusterPresentation(cluster) {
            const weight = cluster.getWeight();

            const styles = {
                'weight < 10': {
                    size: 28,
                    stroke: 4,
                    color: '172, 159, 150',
                    textPosition: { x: 14, y: 20 },
                },
                'weight < 25': {
                    size: 38,
                    stroke: 5,
                    color: '200, 83, 43',
                    textPosition: { x: 19, y: 25 },
                },
                'weight < 50': {
                    size: 38,
                    stroke: 6,
                    color: '123, 9, 3',
                    textPosition: { x: 19, y: 25 },
                },
                'weight < 100': {
                    size: 38,
                    stroke: 8,
                    color: '134, 45, 14',
                    textPosition: { x: 19, y: 25 },
                },
                'weight < 1000': {
                    size: 48,
                    stroke: 12,
                    color: '200, 83, 43',
                    textPosition: { x: 24, y: 30 },
                },
                'weight > 1000': {
                    size: 66,
                    stroke: 20,
                    color: '200, 83, 43',
                    textPosition: { x: 33, y: 38 },
                },
            };

            let style = styles['weight < 10'];

            if (weight < 10) {
                style = styles['weight < 10'];
            } else if (weight < 25) {
                style = styles['weight < 25'];
            } else if (weight < 50) {
                style = styles['weight < 50'];
            } else if (weight < 100) {
                style = styles['weight < 100'];
            } else if (weight < 1000) {
                style = styles['weight < 1000'];
            } else if (weight > 1000) {
                style = styles['weight > 1000'];
            }

            style.diameter = style.size / 2 - style.stroke / 2;
            style.center = style.size / 2;
            style.line = style.size - style.stroke;
            style.padding = style.stroke / 2;

            // Build DOM icon
            const clusterIcon = new H.map.DomIcon(`
                        <div style="width: ${style.size}px; height: ${style.size}px; text-align: center; color: #fff; font-family: 'Barlow Semi Condensed'; font-weight: 500;  border-radius: 50%; background-color: rgba(${style.color}, 0.5); user-select: none; padding: ${style.padding}px">
                            <div style="width: ${style.line}px; height: ${style.line}px; background-color: rgb(${style.color}); border-radius: 50%; line-height: ${style.line}px">
                                ${weight}
                            </div>
                        </div>
                    `);

            // Create a marker for clusters:
            const clusterMarker = new H.map.DomMarker(cluster.getPosition(), {
                icon: clusterIcon,
                // Set min/max zoom with values from the cluster, otherwise
                // clusters will be shown at all zoom levels:
                min: cluster.getMinZoom(),
                max: cluster.getMaxZoom(),
            });

            // SVG Build cluster icon
            /*
                    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" height="${style.size}px" width="${style.size}px"><circle cx="${style.center}px" cy="${style.center}px" r="${style.diameter}" fill="rgb(${style.color})" stroke="rgb(${style.color})" stroke-width="${style.stroke}" stroke-opacity="0.5" />
                            <text x="${style.textPosition.x}" y="${style.textPosition.y}"
                            font-size="11pt" font-family="Barlow Semi Condensed"
                            font-weight="400" text-anchor="middle" fill="white">${weight}</text>
                        </svg>`;

                    const clusterIcon = new H.map.Icon(svgString, {
                        size: { w: style.size, h: style.size },
                        anchor: { x: style.size / 2, y: style.size / 2 },
                    });

                    // Create a marker for clusters:
                    const clusterMarker = new H.map.Marker(
                        cluster.getPosition(),
                        {
                            icon: clusterIcon,
                            // Set min/max zoom with values from the cluster, otherwise
                            // clusters will be shown at all zoom levels:
                            min: cluster.getMinZoom(),
                            max: cluster.getMaxZoom(),
                        },
                    );
                    */

            return clusterMarker;
        },
        getNoisePresentation(noisePoint) {
            return new H.map.Marker(noisePoint.getPosition());
            /*
            // Get a reference to data object from noise points
            const markerData = noisePoint.getData();

            // Create a marker for the noisePoint
            const iconMarker = new H.map.Marker(noisePoint.getPosition(), {
                min: noisePoint.getMinZoom(),
                icon: getLocalIcon(markerData.icon),
                data: {
                    id: markerData.guid,
                },
            });

            // Link a data from the point to the marker
            // to make it accessible inside onMarkerClick
            iconMarker.setData(markerData);

            return iconMarker;
            */
        },
    };

    // Set modified cluster theme
    clusteredDataProvider.setTheme(customTheme);

    const clusteringLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);

    map.addLayer(clusteringLayer);
}

function initHereMap(pois) {
    const platform = new H.service.Platform({
        apikey: window.here.api_key,
    });

    const defaultLayers = platform.createDefaultLayers();

    const map = new H.Map(
        document.getElementById('map'),
        defaultLayers.raster.normal.map,
        {
            center: new H.geo.Point(30.789, 33.79),
            zoom: 2,
            pixelRatio: window.devicePixelRatio || 1,
            engineType: H.map.render.RenderEngine.EngineType.P2D,
        },
    );
    window.addEventListener('resize', () => map.getViewPort().resize());

    // eslint-disable-next-line no-unused-vars
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));

    // eslint-disable-next-line no-unused-vars
    const ui = H.ui.UI.createDefault(map, defaultLayers);

    startClustering(map, pois);
}

export default {
    mounted() {
        this.init();
    },
    methods: {
        init() {
            // initHereMap(airports);
            axios.get('/api/v1/poi/all').then(({ data }) => {
                initHereMap(
                    data.pois.map((item) => ({
                        latitude: item.lat,
                        longitude: item.lng,
                    })),
                );
            });
        },
    },
};
</script>
